import {
  GridCellProps,
  GridColumn as Column,
} from '@progress/kendo-react-grid';
import {
  AsyncLoadingSection,
  buildEndpoint,
  defaultDataTransform,
defaultGridProps,
getFormattedDisplayCell,
GridProvider,
MainGrid,
MultiModalProvider,
PageCard,
PageCardSection,
Render,
TextIconButton,
useDataFetcher,
useToasts,
WrappableCell,
} from '@techsharegov/react-ui';
import Download from '@mui/icons-material/Download';
import Visibility from '@mui/icons-material/Visibility';
import { AgendaEndpoints } from 'Models/Routes';
import { useFileDownloader } from 'Utilities';
import React from 'react';

export class PublicNoticesInfoModel {
  disclaimer?: string;
}

export const PublicNotices: React.FC = () => {
  return (
    <GridProvider entityName="Public Notice">      
      <PublicNoticesGrid />
    </GridProvider>
  );
};

export const PublicNoticesGrid: React.FC = () => {
  const [data, loadingStatus] = useDataFetcher<PublicNoticesInfoModel>(
    buildEndpoint(AgendaEndpoints.publicnotices.controllerActionString("disclaimer")),
    new PublicNoticesInfoModel(),
    defaultDataTransform,
    PublicNoticesInfoModel
  );

  return (
    <PageCard>
      <PageCardSection>
        <AsyncLoadingSection loadingStatus={loadingStatus}>
          <div
            className="whitespace-preline"
            dangerouslySetInnerHTML={{ __html: data.disclaimer === undefined ? "" : data.disclaimer }}
          ></div>
        </AsyncLoadingSection>
      </PageCardSection>      
      <PageCardSection title="Upcoming Events">
        
        <MultiModalProvider>
          <MainGrid
            readEndpoint={AgendaEndpoints.publicnotices.read}
            sortable={true}
            groupable={false}
            {...defaultGridProps}
          >
            <Column field="name" title="Name" cell={NameCell} />
            <Column
              field="meetingDate"
              title="Date"
              cell={getFormattedDisplayCell('meetingDateDisplay')}
              width="80px"
            />
            <Column field="id" title=" " cell={ActionsCell} width="auto" />
          </MainGrid>
        </MultiModalProvider>
      </PageCardSection>
    </PageCard>
  );
};

const NameCell: React.FC<GridCellProps> = ({dataItem}) => (
  <WrappableCell>
    {dataItem.name}
  </WrappableCell>
);

const ActionsCell: React.FC<GridCellProps> = (props: GridCellProps) => {
  const toast = useToasts();
  const { downloadFile } = useFileDownloader();
  const dataItem = props.dataItem;
  
  const downloadPdf = async () => {
    try {
      var url = 
        AgendaEndpoints.publicnotices.controllerActionString('downloadPacket') + 
        '?publicNoticeId=' +
        dataItem.id;
    
      downloadFile(url, 'PublicNotice', true);
    } catch {
      toast.error('Error downloading document.');
    }
  };
  
  const openPdf = async () => {
    try {
      var url = 
        AgendaEndpoints.publicnotices.controllerActionString('downloadPacket') + 
        '?publicNoticeId=' +
        dataItem.id;
    
      downloadFile(url, 'PublicNotice');
    } catch {
      toast.error('Error downloading document.');
    }
  };
  
  return (
    <td>
      <Render condition={dataItem?.hasAttachments}>
        <TextIconButton
          icon={Download}
          onClick={downloadPdf}
          className="single-line-btn"
         />      
      </Render>
      <Render condition={dataItem?.hasAttachments}>
        <TextIconButton
          icon={Visibility}
          onClick={openPdf}
          className="single-line-btn"
        />      
      </Render>
    </td>
  );
};
